import { motion } from "framer-motion";
import { Rise } from "@/components/site/Reveal";
import { ASSETS } from "@/lib/site";

export const AboutGrace = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-ink-charcoal py-32 sm:py-44 overflow-hidden"
    >
      <div className="mx-auto max-w-[1500px] px-6 sm:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
          {/* photo — stark rectangular frame, offset */}
          <Rise className="lg:col-span-5 order-1">
            <div className="relative w-fit mx-auto lg:mx-0">
              <div className="absolute -top-6 -right-6 h-full w-full border border-bone/20" />
              <img
                src={ASSETS.gracePhoto}
                alt="Author Grace Edwards"
                loading="lazy"
                className="relative w-[78vw] max-w-[420px] h-auto grayscale-0 object-cover"
                data-testid="about-photo"
              />
              <span className="absolute -bottom-9 left-0 font-brush text-rust/90 text-lg">
                Grace
              </span>
            </div>
          </Rise>

          <div className="lg:col-span-6 lg:col-start-7 order-2">
            <p className="font-sans text-xs uppercase tracking-[0.4em] text-rust mb-8">
              Meet Grace
            </p>
            <motion.h2
              data-testid="about-title"
              className="font-serif uppercase leading-[1.04] tracking-tight text-bone text-4xl sm:text-5xl lg:text-6xl"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.5 }}
              variants={{
                hidden: {},
                show: { transition: { staggerChildren: 0.08 } },
              }}
            >
              {["SHE RIDES.", "SHE BUILDS.", "SHE QUESTIONS", "EVERYTHING."].map(
                (l, i) => (
                  <motion.span
                    key={i}
                    className="block"
                    variants={{
                      hidden: { opacity: 0, y: 18 },
                      show: {
                        opacity: 1,
                        y: 0,
                        transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
                      },
                    }}
                  >
                    {l}
                  </motion.span>
                ),
              )}
            </motion.h2>
            <Rise delay={0.25} className="mt-8">
              <p className="font-serif italic text-2xl text-bone-soft">
                And she does not sit still.
              </p>
            </Rise>
            <Rise delay={0.35} className="mt-8 max-w-xl space-y-5 font-sans text-base sm:text-lg leading-relaxed text-bone-muted">
              <p>
                Grace Edwards writes for the woman who knows there is more and
                refuses to stay where she has outgrown.
              </p>
              <p>She rides. She builds. She questions everything.</p>
              <p className="text-bone-soft">And she does not sit still.</p>
              <p className="font-serif italic text-bone">
                Author of Ride Like a Lady.
              </p>
            </Rise>
          </div>
        </div>
      </div>
    </section>
  );
};
